<main class="launch-unavailable">
  <section
    class="launch-unavailable-content"
    aria-labelledby="launch-unavailable-title"
  >
    <div class="launch-unavailable-icon" aria-hidden="true">
      <mat-icon>link_off</mat-icon>
    </div>

    <h1
      id="launch-unavailable-title"
      i18n="@@videoAppointmentLaunchUnavailableTitle"
    >
      Video-Appointment kann nicht geöffnet werden
    </h1>

    <p i18n="@@videoAppointmentLaunchUnavailableDescription">
      Dieser Link kann mit dem aktuell angemeldeten Konto nicht geöffnet werden.
      Möglicherweise wurde er bereits von einer anderen Person verwendet, ist
      abgelaufen oder ungültig.
    </p>

    <p
      class="launch-unavailable-security-note"
      i18n="@@videoAppointmentLaunchUnavailableSecurityNote"
    >
      Aus Sicherheitsgründen werden keine Informationen zum Video-Appointment
      angezeigt.
    </p>

    <p
      class="launch-unavailable-guidance"
      i18n="@@videoAppointmentLaunchUnavailableGuidance"
    >
      Bitte verwenden Sie den für Sie bestimmten Link oder fordern Sie einen
      neuen Link an.
    </p>
  </section>
</main>
